import { cn } from "@/lib/utils";

interface CtaHoverProps {
  label?: string;
  /** Typography and resting colour of the label (inherits from the button when omitted). */
  labelClassName?: string;
  /** Colour of the copy that rolls in (the resting colour when omitted). */
  hoverLabelClassName?: string;
  /** Resting and hover fills; when omitted only the label rolls, over the button's own background. */
  fills?: [string, string];
}

const ROLL = "transition-transform duration-500 motion-reduce:transition-none";

/**
 * The homepage CTA hover (CTAButton in shadcn/ui/button.tsx): the fill slides up into the hover
 * fill and the label rolls up into a copy of itself. The button needs `group relative overflow-hidden`.
 */
export default function CtaHover({ label, labelClassName, hoverLabelClassName, fills }: CtaHoverProps) {
  return (
    <>
      {fills && (
        <>
          <span aria-hidden="true" className={cn("absolute inset-0 group-hover:-translate-y-full", ROLL, fills[0])} />
          <span aria-hidden="true" className={cn("absolute inset-0 translate-y-full group-hover:translate-y-0", ROLL, fills[1])} />
        </>
      )}
      <span className="relative block overflow-hidden">
        <span className={cn("block group-hover:-translate-y-full", ROLL, labelClassName)}>{label}</span>
        <span
          aria-hidden="true"
          className={cn("absolute inset-x-0 top-0 block translate-y-full group-hover:translate-y-0", ROLL, labelClassName, hoverLabelClassName)}>
          {label}
        </span>
      </span>
    </>
  );
}
